import postal from 'postal';
import * as serializer from 'jsonrpc-serializer';

export const CHANNEL_REQUEST = 'request';
export const CHANNEL_NOTIFICATION = 'notify';
export const CHANNEL_SUCCESS = 'success';
export const CHANNEL_ERROR = 'error';

const chanels = {
  [CHANNEL_REQUEST]: postal.channel(CHANNEL_REQUEST),
  [CHANNEL_NOTIFICATION]: postal.channel(CHANNEL_NOTIFICATION),
  response: postal.channel('response'),
};

export default {
  [CHANNEL_REQUEST]: {
    publish: (id, method, params, meta = {}) => {
      chanels[CHANNEL_REQUEST].publish(method, {
        ...serializer.requestObject(id, method, params),
        meta,
      });
    },
    subscribe: (method, callback) => chanels[CHANNEL_REQUEST].subscribe(method, callback),
  },
  [CHANNEL_NOTIFICATION]: {
    publish: (method, params, meta = {}) => {
      chanels[CHANNEL_NOTIFICATION].publish(method, {
        ...serializer.notificationObject(method, params),
        meta,
      });
    },
    subscribe: (method, callback) => chanels[CHANNEL_NOTIFICATION].subscribe(method, callback),
  },
  [CHANNEL_SUCCESS]: {
    publish: (id, result, meta = {}) => {
      chanels.response.publish(CHANNEL_SUCCESS, {
        ...serializer.successObject(id, result),
        meta,
      });
    },
    subscribe: callback => chanels.response.subscribe(CHANNEL_SUCCESS, callback),
  },
  [CHANNEL_ERROR]: {
    publish: (id, errorData, meta = {}) => {
      chanels.response.publish(CHANNEL_ERROR, {
        ...serializer.errorObject(id, errorData),
        meta,
      });
    },
    subscribe: callback => chanels.response.subscribe(CHANNEL_ERROR, callback),
  },
};




// WEBPACK FOOTER //
// ./src/WebBridge/protocol/jsonRpc.js